export const helpers = {
  'Invalid phone': 'Telefone inválido',
  'Please, inform a valid email': 'Por favor, informe um email válido',
  'This email is already registered': 'Este email já está registrado',
};
